import Point from "./SettingsUi/Point";
import Text from "./SettingsUi/Text";
import Line from "./SettingsUi/Line";
import Polygon from "./SettingsUi/Polygon";
import Edit from "./SettingsUi/Edit";
import Delete from "./SettingsUi/Delete";

// @ts-ignore
import PointIcon from "./icons/DrawPoint.png";
// @ts-ignore
import MultiPointIcon from "./icons/DrawMultiPoint.png";
// @ts-ignore
import LineIcon from "./icons/DrawLine.png";
// @ts-ignore
import PolyLineIcon from "./icons/DrawPolyline.png";
// @ts-ignore
import FreehandIcon from "./icons/DrawFreehand.png";
// @ts-ignore
import PolygonIcon from "./icons/DrawPolygon.png";
// @ts-ignore
import FreehandPolygonIcon from "./icons/DrawFreehandPolygon.png";
// @ts-ignore
import RectangleIcon from "./icons/DrawRectangle.png";
// @ts-ignore
import TextIcon from "./icons/DrawText.png";
// @ts-ignore
import EditIcon from "./icons/Edit.png";
// @ts-ignore
import DeleteIcon from "./icons/Delete.png";
// @ts-ignore
import EraserIcon from "./icons/Eraser.png";

interface Labels {
  start?: string;
  active?: string;
}
export interface MarkupButton {
  value: string;
  label: string;
  icon: string;
  drawType: string;
  component?: React.FC;
  startDraw?: boolean;
  labels?: Labels;
}
const markupButtons: MarkupButton[] = [
  {
    value: "point",
    label: "Point",
    icon: PointIcon,
    drawType: "point",
    component: Point,
    labels: {
      start: "Click to add a point.",
    },
  },
  {
    value: "multiPoint",
    label: "MultiPoint",
    icon: MultiPointIcon,
    drawType: "multipoint",
    component: Point,
    labels: {
      start: "Click to start adding points.",
      active: "Click to add another point. Double click to finish.",
    },
  },
  // {
  //   value: "line",
  //   label: "Line",
  //   icon: LineIcon,
  //   drawType: "line",
  //   component: Line,
  // },
  {
    value: "polyLine",
    label: "PolyLine",
    icon: PolyLineIcon,
    drawType: "polyline",
    component: Line,
    labels: {
      start: "Click to start drawing a line.",
      active: "Click to add another segment. Double click to finish.",
    },
  },
  // {
  //   value: "freehand",
  //   label: "Freehand",
  //   icon: FreehandIcon,
  //   drawType: "freehand",
  //   component: Line,
  // },
  {
    value: "polygon",
    label: "Polygon",
    icon: PolygonIcon,
    drawType: "polygon",
    component: Polygon,
    labels: {
      start: "Click to start drawing a polygon.",
      active: "Click to add another vertex. Double click to finish.",
    },
  },
  {
    value: "freehandPolygon",
    label: "FreehandPolygon",
    icon: FreehandPolygonIcon,
    drawType: "freehandPolygon",
    component: Polygon,
    labels: {
      start: "Click and drag to draw a polygon.",
      active: "Release to finish drawing the polygon.",
    },
  },
  {
    value: "rectangle",
    label: "Rectangle",
    icon: RectangleIcon,
    drawType: "rectangle",
    component: Polygon,
    labels: {
      start: "Click and drag to draw a rectangle.",
    },
  },
  {
    value: "text",
    label: "Text",
    icon: TextIcon,
    drawType: "point",
    component: Text,
    labels: {
      start: "Click to add text.",
    },
  },
  {
    value: "edit",
    label: "Edit",
    icon: EditIcon,
    startDraw: false,
    drawType: "edit",
    component: Edit,
  },
  {
    value: "delete",
    label: "Delete",
    icon: DeleteIcon,
    startDraw: false,
    drawType: "delete",
    component: Delete,
  },
  {
    value: "eraser",
    label: "Clear All",
    icon: EraserIcon,
    startDraw: false,
    drawType: "eraser",
  },
];

export default markupButtons;
